// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__b6fu+","left":"Virtual_left__1vMq4","wrapper":"Virtual_wrapper__kEok6"};